module.exports = "const float PI = 3.141592653589793;\r\nuniform sampler2D u_Texture;\r\nuniform vec2 u_Center;\r\nuniform float u_Radius;\r\nuniform float u_Strength;\r\nvarying vec2 v_Uv;\r\nvoid main() {\r\n    vec4 info = texture2D(u_Texture, v_Uv);\r\n    float drop = max(0.0, 1.0 - length(u_Center - v_Uv) / u_Radius);\r\n    drop = 0.5 - cos(drop * PI) * 0.5;\r\n    info.r += drop * u_Strength;\r\n    gl_FragColor = info;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/js/shader/vertexInfo/dropShader.glsl
// module id = 20
// module chunks = 0